{
  "colorSwatchPicker": "Uzorci boje",
  "dropzoneLabel": "DropZone",
  "selectPlaceholder": "Izaberite stavku",
  "tableResizer": "Promena veličine"
}
